// extracted by mini-css-extract-plugin
export default {"container":"K7lNb","dropdownLink":"l8Uds","dropdown-container":"ItTuU","dropdownContainer":"ItTuU","dropdown-item":"SC6aA","dropdownItem":"SC6aA","text":"GpZ6j","separator":"QcLrF"};